---
en:
  budget_import:
    dialog_title: Import Budget Data
    file_too_large: File is too large
    import_button: Import Budget Data
    invalid_file: The file could not be read. It may be corrupted or in the wrong format.
    no_file_selected: Please select a file to upload
    select_file: Select XLSX or CSV file
    upload: Upload
    upload_failed: Failed to upload file
  budget_tabs:
    charts: Charts
    tables: Tables
  budgets:
    edit_title: Budget for
